import React from "react";
import ListPositions from "../../../containers/Settings/Positions/index";

const SettingDepartment = () => {
  return <ListPositions />;
};
export default SettingDepartment;
